// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__102ia","label":"styles_label__2zxwG"};